module.exports = __webpack_public_path__ + "assets/img/33_1567_big.28159145.jpg";